import React from "react";
import ReportRoundedIcon from "@mui/icons-material/ReportRounded";
import "../components/ending/ending-pages.css";

const DEFAULT_MESSAGE = "We ran into an unexpected problem. Please try again, or contact support if this keeps happening.";

const Error = ({ ErrorMessage }) => {
  const message = ErrorMessage && ErrorMessage !== "loading" ? ErrorMessage : DEFAULT_MESSAGE;

  return (
    <div
      className="relative flex min-h-screen w-full items-center justify-center overflow-hidden px-4 py-10"
      style={{ background: "linear-gradient(160deg, #fef2f2 0%, #fee2e2 55%, #fecaca 100%)" }}
    >
      <div className="rf-ending-rise relative z-10 w-full max-w-md rounded-3xl bg-white p-8 text-center shadow-[0_20px_50px_rgba(0,0,0,0.08)]">
        <div className="flex justify-center">
          <div
            className="rf-ending-glow flex h-24 w-24 items-center justify-center rounded-full"
            style={{ background: "rgba(220,38,38,0.12)", "--rf-glow-color": "rgba(220,38,38,0.3)" }}
          >
            <ReportRoundedIcon sx={{ fontSize: 56, color: "#dc2626" }} />
          </div>
        </div>

        <h1 className="rf-ending-rise-delay-1 mt-6 text-2xl font-bold text-gray-900">Oops! Something went wrong</h1>

        <div
          className="rf-ending-rise-delay-1 mt-4 rounded-xl border-l-4 px-4 py-3 text-left text-sm italic text-gray-600"
          style={{ borderColor: "#dc2626", background: "rgba(220,38,38,0.08)" }}
        >
          {message}
        </div>

        <p className="rf-ending-rise-delay-2 mt-6 text-xs text-gray-400">You may now safely close this tab.</p>
      </div>
    </div>
  );
};

export default Error;
